/**
 * view.js — Invoice Generation Block Entry Point
 *
 * Bootstraps the block on the frontend:
 *  api.js           → WP REST wrapper
 *  invoice-check.js → Receipt lookup, row rendering, submit advance
 *  modal-system.js  → Shared modal controller
 */

import InvoiceGenerationAPI from './api';
import InvoiceModal from './modal-system';
import { initReceiptCheck } from './invoice-check';
import { initBuyerStep } from './buyer-step';

document.addEventListener('DOMContentLoaded', () => {
	const api = new InvoiceGenerationAPI();
	const modal = new InvoiceModal();

	document
		.querySelectorAll('.wp-block-cancan-invoice-generation')
		.forEach((wrapper) => {
			const form = wrapper.querySelector('.ig-form');
			if (!form) return;

			const swiper = initSlider(wrapper);

			let checkControl, buyerControl;

			const resetAll = () => {
				checkControl?.reset();
				buyerControl?.reset();
				if (swiper) swiper.slideTo(0);
			};

			checkControl = initReceiptCheck(form, swiper, api, modal);
			buyerControl = initBuyerStep(
				form,
				swiper,
				api,
				modal,
				checkControl,
				resetAll
			);
		});
});

// ─── Slider ──────────────────────────────────────────────────────────────────

/**
 * Initialise the Swiper instance for the given block wrapper.
 * Mirrors the card-registration slider config.
 *
 * @param   {HTMLElement}                     wrapper
 * @returns {import('swiper').default | null}
 */
function initSlider(wrapper) {
	const swiperEl = wrapper.querySelector('.swiper');
	if (!swiperEl) return null;

	const swiper = new Swiper(swiperEl, {
		slidesPerView: 1,
		spaceBetween: 10,
		loop: false,
		allowTouchMove: false,
		autoHeight: true,
	});

	const resizeObserver = new ResizeObserver(() => {
		requestAnimationFrame(() => swiper.updateAutoHeight(0));
	});
	swiperEl
		.querySelectorAll('.swiper-slide')
		.forEach((slide) => resizeObserver.observe(slide));

	return swiper;
}
